import axios from "axios";
import Vue from "vue";


window.MENU_UPDATE_FLAG = true;

function listenMenu () {


	let delta = 64;
	let lastScrollPosition = 0;


	let scrollingContainer = window;
	let header = document.querySelector(".menu-container");

	scrollingContainer.addEventListener("scroll", debounce(function (e) {
		if (window.MENU_UPDATE_FLAG) {
			let currentScrollPosition = scrollingContainer.scrollY;

			if (currentScrollPosition > delta) {

				if (lastScrollPosition < currentScrollPosition) {
					//scrolled down
					header.classList.add("nav-hidden");
				} else {
					//scrolled up
					header.classList.remove("nav-hidden");
				}

			} else {
				header.classList.remove("nav-hidden");
			}

			lastScrollPosition = currentScrollPosition;
		}

	},100));
}


document.addEventListener('DOMContentLoaded', function () {
	new Vue({
		el: ".menu-container",
		data() {
			return {
				isOpen: false,
				showing: "",
				destinations: [
					{
						"name": "Bethlehem",
						"link": "/destinations/bethlehem/",
						"image": "/wp-content/uploads/2016/06/Bethlehem-3.jpg",
					},
					{
						"name": "Gaza",
						"link": "/destinations/gaza/",
						"image": "/wp-content/uploads/2016/12/Gaza.jpg",
					},
					{
						"name": "Hebron",
						"link": "/destinations/hebron/",
						"image": "/wp-content/uploads/2016/06/160146438-2.jpg",
					},
					{
						"name": "Jenin",
						"link": "/destinations/jenin/",
						"image": "/wp-content/uploads/2016/06/Jenin-Old-City.jpg",
					},
					{
						"name": "Jericho",
						"link": "/destinations/jericho/",
						"image": "/wp-content/uploads/2016/06/Jericho-Hishams-Palace-1.jpg",
					},
					{
						"name": "Jerusalem",
						"link": "/destinations/jerusalem/",
						"image": "/wp-content/uploads/2016/06/Jerusalem100.jpg",
					},
					{
						"name": "Nablus",
						"link": "/destinations/nablus/",
						"image": "/wp-content/uploads/2016/06/Nablus-Mt-Jarzim-1.jpg",
					},
					{
						"name": "Qalqilya",
						"link": "/destinations/qalqilya/",
						"image": "/wp-content/uploads/2016/06/Jinsafut-1.jpg",
					},
					{
						"name": "Ramallah & Al Bireh",
						"link": "/destinations/ramallah-al-bireh/",
						"image": "/wp-content/uploads/2016/06/458326105.jpg",
					},
					{
						"name": "Salfit",
						"link": "/destinations/salfit/",
						"image": "/wp-content/uploads/2016/06/Salfit-1.jpg",
					},
					{
						"name": "Tubas",
						"link": "/destinations/tubas/",
						"image": "/wp-content/uploads/2016/06/Tubas.jpg",
					},
					{
						"name": "Tulkarem",
						"link": "/destinations/tulkarem/",
						"image": "/wp-content/uploads/2016/06/Tulkarem-City-1.jpg",
					},
				],
				news: []
			}
		},
		mounted() {
			this.$nextTick(() => {
				//this only works on the frikin navbar
				document.querySelector(".st-content-inner").addEventListener("click", this.closeMenu.bind(this));
				listenMenu();
			});
		},
		computed: {
			destinationEditedImages() {
				return this.destinations.map(function (destination) {
					let shallowCopy = Object.assign({}, destination);
					shallowCopy.image = `https://rsz.io/www.welcometopalestine.com/${destination.image}?width=200`;
					return shallowCopy;
				});
			}
		},
		methods: {
			getParsedTitle(title) {
				let txt = document.createElement("textarea");
				txt.innerHTML = title;
				return txt.value;
			},
			fetchNews() {
				if (!this.news.length) {
					axios.get("/wp-json/news/v2/news")
						.then((response) => {
							this.news = response.data;
						})
				}
			},
			openMenu() {
				this.isOpen = !this.isOpen;
				if (this.isOpen) {
					document.querySelector(".menu-container").classList.remove("nav-hidden");
					document.querySelector(".st-container").classList.add("st-menu-open");
					document.querySelector("body").classList.add("prevent-scrolling");

					//transform messes with the current animations
					document.querySelector(".st-menu").style.top = window.scrollY + "px";

					//transform has rendering issues when transitioning
					document.querySelector(".menu-container").style.top = window.scrollY + "px";

				} else {
					document.querySelector(".menu-container").style.top = "";
					document.querySelector(".st-container").classList.remove("st-menu-open");
					document.querySelector("body").classList.remove("prevent-scrolling");
				}
			},
			show(section) {
				this.showing = section;
				switch (section) {
					case "news":
						this.fetchNews();
						break;
				}
			},
			hide() {
				this.showing = "";
			},
			closeMenu() {
				if (this.isOpen) {
					this.isOpen = false;
					document.querySelector(".menu-container").style.top = "";
					document.querySelector(".st-container").classList.remove("st-menu-open");
					document.querySelector("body").classList.remove("prevent-scrolling");
				}
			}
		}
	});
});


// WEBPACK FOOTER //
// ./src/menu.js